import { mapState } from 'vuex';

//- 分頁器
import PagenationComponent from '@/components/Pagenation/Pagenation.vue';

//- 禮物
import GiftItemComponent from '@/components/GiftItem/GiftItem.vue';
//- 禮物兌換紀錄
import GiftExchangeRecordModalComponent from '@/components/GiftExchangeRecordModal/GiftExchangeRecordModal.vue';
//- 點數紀錄
import PointsRecordModalComponent from '@/components/PointsRecordModal/PointsRecordModal.vue';


export default {
  name: 'GiftIndex',
  components: {
    PagenationComponent,
    GiftItemComponent,
    GiftExchangeRecordModalComponent,
    PointsRecordModalComponent,
  },
  data() {
    return {
      //- 分頁器內容
      pagenationData: {
        //- 目前頁面
        currentPage: 1,
        //- 一頁幾筆
        perPage: 5,
        //- 總筆數
        total: 0,
      },
      //- 顯示禮物兌換紀錄的內容
      isGiftExchangeRecordModalShow: false,
      //- 顯示點數紀錄的內容
      isPointsRecordModalShow: false,
    }
  },
  mounted() {
    let vm = this;
    //- 取得禮物
    vm.$store.dispatch('gift_manager/index').then(() => {
      //- 帶入正確的頁數
      vm.pagenationData = vm.$_.cloneDeep(vm.pagination);
    });
  },
  methods: {
    //- 換頁
    changePageHandler: function(page) {
      let vm = this;
      let pageData = {
          page: page
        }
        //- 取得禮物
      vm.$store.dispatch('gift_manager/index', pageData).then(() => {
        //- 帶入正確的頁數
        vm.pagenationData = vm.$_.cloneDeep(vm.pagination);
        //- 重置幻燈片及方向
        vm.$_.forEach(vm.$refs.GiftItemComponent, function(i, k) {
          i.resetHandler();
        });
        setTimeout(() => {
          vm.$('body,html').animate({
            scrollTop: 0
          }, 500);
        }, 50);

      });
    },
    //- 打開彈窗
    showModalHandler: function(type) {
      let vm = this;
      //- 判斷打開哪一個
      switch (type) {
        case 'GiftExChangeRecord':
          //- 已經打開就返回
          if (vm.isGiftExchangeRecordModalShow === true) return;
          vm.isGiftExchangeRecordModalShow = true;
          //- 初始化禮物兌換紀錄
          vm.$refs.GiftExchangeRecordModal.resetHandler();
          break;
        case 'pointsRecord':
          //- 已經打開就返回
          if (vm.isPointsRecordModalShow === true) return;
          vm.isPointsRecordModalShow = true;
          //- 初始化禮物兌換紀錄
          vm.$refs.PointsRecordModal.resetHandler();
          break;
        default:
          break;
      }
    },
    //- 兌換禮物
    exchangeGiftHandler: function(gift) {
      let vm = this;
      if (parseInt(gift.rest_number) === 0) return;
      const updateMemberInfoUrl = process.env.VUE_APP_UPDATE_MEMBER_INFO_URL;
      vm.$Swal.fire({
        title: '您確定要兌換？',
        html: `<span>您確定要花費 <code>${gift.points}</code> 點兌換 <code>${gift.name}</code>？</span><br> <code>兌換前務必確認您的銀行與分行是否正確，若有異動請至『<a href="${updateMemberInfoUrl}"> 會員資料更新</a> 』進行申請。</code>`,
        icon: 'question',
        heightAuto: false,
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        confirmButtonColor: '#0A94CC',
        cancelButtonColor: '#ff0000'
      }).then((res) => {
        //- 按下確定
        if (res.value) {
          //- 打兌換禮物的 ＡＰＩ
          vm.$store.dispatch('gift_manager/exchange', gift.id)
            .then(res => {
              vm.$snotify.success(null, res.data.message);
            })
            .catch(err => {
              vm.$snotify.error(err.data.message, '兌換失敗');
            })
            .then(() => {
              //- 重新打一次首頁的 ＡＰＩ 刷新禮物
              let input = {};
              input.page = vm.pagenationData.currentPage;
              vm.$store.dispatch('gift_manager/index', input);
            })
        }
      })
    },
    updateMember() {
      window.location.href = process.env.VUE_APP_UPDATE_MEMBER_INFO_URL
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo, //- Line 名稱, 大頭貼, 狀態, Uuid ...等等
      points: state => state.gift_manager.points, //- 使用者點數
      giftsList: state => state.gift_manager.giftsList, //- 禮物列表
      pagination: state => state.gift_manager.pagination, //- 首頁的分頁
      allData: state => state.gift_manager.allData,    //- 使用者 會員屬性 累積點數 首頁資料 ...等等
    }),
  }
}
